// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ArrowUp(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ArrowUp" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.7338 7.73529L4.76397 13.5026L3 11.6947L12 3L21 11.6947L19.236 13.5026L13.2662 7.73529L13.2662 21L10.7338 21L10.7338 7.73529Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ArrowUp.js.map